import { render } from "./TestLanding.vue?vue&type=template&id=24ced703&scoped=true"
import script from "./TestLanding.vue?vue&type=script&lang=js"
export * from "./TestLanding.vue?vue&type=script&lang=js"

import "./TestLanding.vue?vue&type=style&index=0&id=24ced703&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ced703"]])

export default __exports__